import React from 'react'
import "../../../styles/interviewScheduleStyle.css"


const mappedStats = [
  { type: "Total Interview Scheduled ", count: 0, role: null },
  { type: "Upcoming Interviews", count: 0, role: "hiring-manager" },
  { type: "Total candidate interviewed", count: 0, role: "recruiter" },
  { type: "Cancelled", count: 0, role: "team-member" }
]

const InterviewSchedule = () => {
  return (
    <div className='jobpost-dashboard' style={{ minHeight: "100vh", padding: "20px", marginTop: "91px", display: "flex", flexDirection: "column", gap: "10px" }}>
      <div className='interview-uppar-section'>
        <div className='interview-left-uppar'>
          <div className='interview-left-first'>
            <div className='interview-status-heading'>
              <p className='team-staut-heading'>Total Interview Schedule</p>
              <div style={{ display: 'flex', gap: "5px", alignItems: "center" }}>
                <p className='interview-all-filter'>All</p>
                <select
                  id="timeFilter"
                  name="timeFilter"
                  className='dropdown-filter-month'
                // value={timeFilter}
                // onChange={handleTimeFilterChange}
                >
                  <option value="yearly">Year</option>
                  <option value="monthly">Month</option>
                  <option value="weekly">Week</option>
                </select>

              </div>
            </div>

            <div className="team-container">

              {mappedStats.map((item, index) => (
                <div
                  key={index}
                  className='interview-team-box'
                //className={`team-box ${currentFilter === item.role ? 'active-filter' : ''}`}
                // onClick={() => handleStatusFilter(item.role)}
                >
                  <div className='interview-team-content'>
                    <h3 className="team-name">{item.count}</h3>
                    <span className="navigate-icon">{">"}</span>

                  </div>
                  <p className="team-count">{item.type}</p>
                </div>
              ))}
            </div>
          </div>
          <div className='interview-left-second'>
            <div className='interview-status-heading'>
              <p className='team-staut-heading'>Today</p>
            </div>

            <div className="interview-team-container">
              <div
                className='interview-team-box' style={{ flexDirection: "row", alignItems: "center" }}
              //className={`team-box ${currentFilter === item.role ? 'active-filter' : ''}`}
              // onClick={() => handleStatusFilter(item.role)}
              >
                <div className='team-content'>
                  <h3 className="team-name">+3</h3>
                  <p className='interview-title'>More interviews</p>
                </div>
                <span className="navigate-icon">{">"}</span>
              </div>
              <div
                className='interview-team-box' style={{ flexDirection: "row", alignItems: "center" }}
              //className={`team-box ${currentFilter === item.role ? 'active-filter' : ''}`}
              // onClick={() => handleStatusFilter(item.role)}
              >
                <div className='team-content'>
                  <p className='interview-time'>28 Feb 2025, 07:00pm</p>
                  <p className='interview-title'>Software developer</p>
                  <p className='interview-company'>XYZ company</p>
                </div>
                <span className="navigate-icon">{">"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='interview-lower-section'>
        <div className="interview-lower-left">
          <h3 className="schedule-heading">Schedule List</h3>
          <table className="schedule-table">
            <thead>
              <tr>
                <th>Appoint for</th>
                <th>Name</th>
                <th>Date & time</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Company/position</td>
                <td>Brad James</td>
                <td>July 24, 2025 | 8 pm</td>
                <td>Video call</td>
              </tr>
              <tr>
                <td>Company/position</td>
                <td>Christy Geller</td>
                <td>July 14, 2025 | 10 am</td>
                <td>Voice call</td>
              </tr>
              <tr>
                <td>Company/position</td>
                <td>Saurabh Jill</td>
                <td>July 9, 2025 | 11 am</td>
                <td>In person</td>
              </tr>
              <tr>
                <td>Company/position</td>
                <td>Monica Darcy</td>
                <td>July 11, 2025 | 8 pm</td>
                <td>Video call</td>
              </tr>
              <tr>
                <td>Company/position</td>
                <td>Bonnie</td>
                <td>July 15, 2025 | 10 am</td>
                <td>Voice call</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="interview-lower-right">
          <div className="appointment-header">
            <h3>Appointment Request</h3>
            <a href="#" className="see-all">See all</a>
          </div>
          <ul className="appointment-list">
            {[
              { name: 'Jesica K', experience: '5 years', time: '6:30pm, 29 feb 2025' },
              { name: 'Monica Jessy', experience: '3 years', time: '8:30pm, 19 feb 2025' },
              { name: 'Nina William', experience: '5 years', time: '6:30pm, 24 feb 2025' },
              { name: 'Saurabh Singh', experience: '5 years', time: '6:30pm, 12 feb 2025' },
              { name: 'Monali S', experience: '2 years', time: '2:30pm, 11 feb 2025' },
              { name: 'Rohit Raj', experience: '5 years', time: '6:30pm, 29 feb 2025' },
              { name: 'Jimmy Singh', experience: '5 years', time: '6:30pm, 29 feb 2025' }
            ].map((item, index) => (
              <li className="appointment-item" key={index}>
                <div className="avatar-placeholder"></div>
                <div className="appointment-details">
                  <strong>{item.name}</strong>
                  <p>+{item.experience} experience</p>
                  <p className="date-time">{item.time}</p>
                </div>
                <div className="appointment-actions">
                  <button className="accept-btn">Accept</button>
                  <button className="reject-btn">Reject</button>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

    </div>
  )
}

export default InterviewSchedule